<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div class="bg-products-cot h-auto mb-12" style="height: auto !important">
      <div class="container">
        <!-- CATALOGUE -->
        <div class="container mx-auto my-12 bg-white/40">
          <div
            class="flex mb-8 text-base font-normal text-theme-9 cursor-pointer"
            @click="$router.back()"
          >
            <ArrowLeftIcon />Regresar
          </div>
          <div class="mb-12">
            <h1 class="font-crimson_pro text-3xl font-bold text-theme-9 text-center">
              Aviso de privacidad
            </h1>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b
              >Usted expresamente acepta esta Política de Privacidad al navegar
              por, o utilizar nuestros productos, contenido, funcionalidades,
              tecnología o funciones disponibles en nuestro sitio web
              www.brandin.com.mx
            </b>
            <p>
              <b>ARTÍCULOS PROMOCIONALES BRAND IN, S.A. DE C.V.</b>, [en lo
              sucesivo <b>BRANDIN</b>], con domicilio en
              <b
                >AVENIDA VASCO DE QUIROGA, NÚMERO 3900, A-401, SANTA FE
                CUAJIMALPA, ALCALDÍA CUAJIMALPA DE MORELOS, EN LA CIUDAD DE
                MÉXICO, CÓDIGO POSTAL 05348</b
              >, es responsable del tratamiento de los datos personales
              recabados en este sitio web y suscribe el presente aviso de
              privacidad en cumplimiento con la Ley Federal de Protección de
              Datos Personales en Posesión de los Particulares.
            </p>
            <p>
              Los datos personales que usted nos ha proporcionado directamente o
              a través de medios electrónicos han sido recabados y serán
              tratados por Brand In, bajo los principios de licitud,
              consentimiento, información, calidad, finalidad, lealtad,
              proporcionalidad y por la Ley Federal de Protección de Datos
              Personales en Posesión de los Particulares.
            </p>
            <p>
              Los datos personales proporcionados a BRANDIN se encontrarán
              debidamente protegidos a través de medidas de seguridad
              tecnológica, física y administrativa, previniendo el uso o
              divulgación indebida de los mismos.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>I. DATOS PERSONALES QUE SE RACABAN. </b>
            <p>
              Para las finalidades señaladas en el presente aviso de privacidad,
              podemos recabar sus datos personales de distintas formas: (i)
              cuando visita nuestro sitio web www.brandin.com.mx, (ii) cuando
              usted nos los proporciona directamente información para la
              cotización de productos, (iii) cuando utiliza nuestros servicios
              en línea y (iv) cuando obtenemos información a través de otras
              fuentes que están permitidas por la ley.
            </p>
            <ul class="list-disc pl-6">
              <li><b>Datos de identificación:</b></li>
              <ul class="pl-6">
                <li>
                  <b>a. Persona Física</b> Los datos de identificación que
                  podemos recabar de una persona física son:
                  <ul class="list-[circle] pl-6">
                    <li>Nombre completo.</li>
                    <li>Clave Única de Registro de Población (CURP).</li>
                    <li>Registro Federal de Contribuyentes (RFC).</li>
                    <li>Nacionalidad.</li>
                    <li>Fecha y lugar de nacimiento.</li>
                    <li>Identificación oficial.</li>
                    <li>Firma autógrafa.</li>
                    <li>
                      Nombre y datos de contacto de personas autorizadas para
                      recibir productos.
                    </li>
                    <li>Nombre del representante legal (en su caso).</li>
                  </ul>
                </li>
                <li>
                  <b>b. Persona Moral.</b> En el caso de personas morales, los
                  datos de identificación pueden incluir:
                  <ul class="list-[circle] pl-6">
                    <li>Razón social.</li>
                    <li>Registro Federal de Contribuyentes (RFC).</li>
                    <li>Domicilio fiscal y de correspondencia.</li>
                    <li>Constancia de situación fiscal.</li>
                    <li>Datos de constitución.</li>
                    <li>Nombre del representante legal.</li>
                    <li>Poderes notariales (cuando apliquen).</li>
                  </ul>
                </li>
              </ul>
              <li>
                <b>Datos de contacto:</b> Teléfonos, correos electrónicos,
                dirección de entrega, domicilio fiscal y de correspondencia,
                correo o medios para notificación de entrega.
              </li>
              <li>
                <b>Datos fiscales:</b> Registro Federal de Contribuyentes (RFC),
                régimen fiscal, uso de CFDI, Constancia de situación fiscal,
                razón social, domicilio fiscal.
              </li>
              <li>
                <b>Datos financieros o patrimoniales:</b> como podría ser cuenta
                bancaria (CLABE), nombre del banco, y demás datos para emisión
                de facturas.
              </li>
              <li>
                <b>Datos de entrega y comprobación:</b> nombre y datos de
                personas autorizadas para recibir productos, firmas autógrafas
                de las personas que reciben productos, acuse de entrega de
                productos.
              </li>
            </ul>
            <p>
              En caso de ser necesario, BRANDIN podrá solicitar documentación
              adicional para cumplir con requerimientos legales o fiscales.
            </p>
            <p>
              BRANDIN no solicitará datos personales sensibles a sus clientes de
              manera habitual. Sin embargo, en caso de que por la naturaleza de
              la relación jurídica se requiera el tratamiento de algún Dato
              Personal Sensible (tales como información de salud, creencias
              religiosas, afiliación sindical o datos biométricos), se le
              informará de manera expresa y se solicitará el consentimiento
              previo, expreso y por escrito, conforme a lo dispuesto en la Ley
              Federal de Protección de Datos Personales en Posesión de los
              Particulares y su Reglamento.
            </p>
            <p>
              Dichos datos, en caso de ser recabados, serán tratados únicamente
              para cumplir con las obligaciones derivadas de la relación
              jurídica establecida entre usted y BRANDIN, y serán resguardados
              con las medidas de seguridad adecuadas para garantizar su
              confidencialidad, integridad y disponibilidad.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>II. FINALIDADES DEL TRATAMIENTO. </b>
            <p>
              La información que nos proporciona será utilizada para las
              siguientes finalidades primarias:
            </p>
            <ul class="list-disc pl-6">
              <li>
                Seguimiento a solicitudes de información sobre los servicios y/o
                productos que nuestra empresa
              </li>
              oferta por medio de nuestro sitio web u otros medios.
              <li>
                Dar cumplimiento a obligaciones contraídas en la relación
                comercial.
              </li>
              <li>
                Atender y dar seguimiento a solicitudes de información o
                cotizaciones.
              </li>
              <li>
                Enviar el catálogo digital de productos ofrecidos por la
                empresa.
              </li>
              <li>
                Establecer comunicación con fines comerciales relacionados con
                nuestros productos.
              </li>
              <li>
                Registrar información para la preparación de cotizaciones o
                propuestas comerciales.
              </li>
              <li>
                Emitir comprobantes fiscales digitales (CFDI) y dar cumplimiento
                a obligaciones fiscales.
              </li>
              <li>
                Gestionar procesos de entrega de productos o servicios
                contratados.
              </li>
              <li>
                Verificar la identidad del cliente o de la persona moral que
                representa.
              </li>
            </ul>
            <p>
              Además de las finalidades primarias necesarias para cumplir con la
              relación comercial entre usted y BRANDIN, sus datos personales
              podrán ser utilizados para las siguientes finalidades secundarias:
            </p>
            <ul class="list-disc pl-6">
              <li>
                Informar sobre cambios y nuevos productos y/o servicios que
                estén relacionados con el/los contratado(s) o adquirido(s) con
                nosotros.
              </li>
              <li>
                Elaborar perfiles con base en el historial de consumo de
                nuestros clientes.
              </li>
              <li>
                Comunicar campañas y contenido publicitarias de productos y/o
                servicios de la empresa a través de cualquier medio digital
                difundido por medio de redes de comunicación de Internet o
                telefonía, tales como correo electrónico, aplicaciones móviles,
                redes sociales en internet, mensajes texto, o cualquier otro
                similar.
              </li>
              <li>
                Evaluar la calidad del servicio, realizar estudios internos,
                encuestas de comportamiento y mercadeo a través de empresas
                reconocidas, todo esto relacionado con la calidad del servicio,
                hábitos de consumo, preferencias de productos que
                comercializamos y demás elementos que permitan ofrecer y
                satisfacer las necesidades de nuestros distribuidores, en el
                ámbito de nuestras relaciones comerciales.
              </li>
            </ul>
            <p>
              Su información se mantendrá en nuestros registros y sistemas
              digitales y/o físicos; a partir de la fecha efectiva en que es
              recibida por BRANDIN por lo que es necesario que nos envíe vía
              correo electrónico su petición de revocación o eliminación de su
              información al correo arely.ayala@brandin.com.mx
            </p>
            <p>
              El Titular de los datos personales tiene derecho de acceder,
              rectificar y cancelar sus datos personales, así como a oponerse a
              que sus datos personales sean usados para los fines antes
              descritos, o revocar el consentimiento que para tal fin nos haya
              otorgado, así como si limitar el uso o divulgación de los datos
              para lo cual se podrá comunica con nosotros mediante correo
              electrónico arely.ayala@brandin.com.mx para hacer del conocimiento
              su petición.
            </p>
            <p>
              En caso contrario, se entenderá que el Titular consiente el
              tratamiento de sus datos para todos los fines enumerados
              anteriormente. Lo anterior es sin perjuicio de lo señalado en el
              artículo 26 de la Ley Federal de Protección de Datos Personales en
              Posesión de los Particulares y demás disposiciones aplicables. El
              Titular podrá manifestar su negativa al uso de sus datos para
              finalidades secundarias enviando un correo a
              arely.ayala@brandin.com.mx en cualquier momento, sin que esto
              afecte las finalidades primarias necesarias
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b
              >III. INFORMACIÓN A TRAVÉS DE COOKIES, WEB BEACONS Y APLICACIONES.
            </b>
            <p>
              Nuestro sitio web puede utilizar cookies, web beacons y otras
              tecnologías similares para monitorear el comportamiento de
              navegación de los usuarios y mejorar su experiencia en el sitio.
              Esta información puede incluir datos como la dirección IP, tipo de
              navegador, tiempo de navegación y páginas visitadas.
            </p>
            <p>
              Estas tecnologías no recaban información personal identificable
              directamente, y pueden ser deshabilitadas por usted desde la
              configuración de su navegador.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>IV. TRANSFERENCIA DE DATOS PERSONALES. </b>
            <p>
              BRANDIN podrá transferir sus datos personales, tanto a entidades
              nacionales como extranjeras, sin requerir su consentimiento, en
              los siguientes casos:
            </p>
            <ul class="list-disc pl-6">
              <li>
                A <b>autoridades fiscales, administrativas o judiciales</b>,
                cuando lo requieran, en cumplimiento de obligaciones legales.
              </li>
              <li>
                A <b>instituciones bancarias</b>, para la realización de pagos u
                emisión de facturas relacionados con la relación comercial.
              </li>
              <li>
                A
                <b
                  >empresas afiliadas, subsidiarias o del mismo grupo
                  corporativo</b
                >, únicamente cuando sea necesario para las finalidades
                establecidas en el presente Aviso de Privacidad.
              </li>
              <li>
                A <b>terceros que presten servicios a BRANDIN</b>, incluyendo
                servicios de recursos humanos, logística, administración de
                proveedores, auditoría, o tecnologías de la información, que
                requieran tratar datos personales por cuenta de BRANDIN.
              </li>
              <li>
                A
                <b
                  >empresas afiliadas, subsidiarias, nacionales o extranjeras</b
                >
                que sean parte del mismo grupo empresarial o socios comerciales
                de BRANDIN, siempre que operen bajo políticas similares en
                materia de protección de datos personales. Estas transferencias
                podrán tener como finalidad llevar a cabo actividades de
                promoción u ofrecimiento de productos y/o servicios que dichas
                empresas comercialicen, de manera conjunta o independiente.
              </li>
              <li>
                A
                <b
                  >contratistas, asesores, prestadores de servicios o
                  proveedores</b
                >
                con los que BRANDIN tenga celebrados acuerdos jurídicos
                vinculantes, y que actúen como encargados o responsables del
                tratamiento, para complementar o coadyuvar en la ejecución de la
                relación jurídica existente.
              </li>
              <li>
                A
                <b
                  >terceros con los que BRANDIN haya celebrado acuerdos
                  jurídicos</b
                >, con la finalidad de dar cumplimiento a las finalidades
                previstas en este Aviso de Privacidad, incluyendo la
                comercialización, asistencia, gestión de relaciones comerciales,
                validación de cumplimiento contractual o determinación de
                elegibilidad respecto de los productos o servicios ofrecidos.
              </li>
            </ul>
            <p>
              En todos los casos anteriores, BRANDIN se asegurará de que se
              cumplan los principios de protección de datos personales y que se
              mantengan las medidas de seguridad, confidencialidad y legalidad
              exigidas por la normatividad aplicable.
            </p>
            <p>
              Estas transferencias se realizan conforme a lo previsto en los
              <b>artículos 36 y 37 de la LFPDPPP</b>.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>V. MEDIDAS DE SEGURIDAD. </b>
            <p>
              BRANDIN ha implementado medidas de seguridad físicas, técnicas y
              administrativas necesarias para proteger sus datos personales
              contra daño, pérdida, alteración, destrucción o acceso no
              autorizado, conforme a lo establecido por la legislación
              aplicable.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>VI. DERECHOS ARCO Y MEDIOS PARA EJERCERLOS. </b>
            <p>Usted tiene derecho a:</p>
            <ul class="list-disc pl-6">
              <li><b>Acceder</b> a sus datos personales,</li>
              <li><b>Rectificarlos</b> si son inexactos o incompletos,</li>
              <li>
                <b> Cancelarlos</b> cuando considere que no se requieren para
                las finalidades descritas,
              </li>
              <li>
                <b>Oponerse</b> al tratamiento de estos para fines específicos.
              </li>
            </ul>
            <p>
              Para ejercer estos derechos, deberá enviar una solicitud al
              correo: arely.ayala@brandin.com.mx, dirigida al Departamento de
              Datos Personales, acompañada de:
            </p>
            <ul class="list-disc pl-6">
              <li>Nombre completo del titular,</li>
              <li>Copia de identificación oficial vigente,</li>
              <li>Descripción clara del derecho que desea ejercer,</li>
              <li>
                Cualquier documento que facilite la localización de sus datos.
              </li>
              <li>
                La respuesta se enviará en un plazo máximo de 20 días hábiles y,
                en caso de ser procedente, se hará efectiva dentro de los 15
                días hábiles siguientes.
              </li>
            </ul>
            <p>
              Atenderemos su solicitud de lunes a viernes, de 8:00 a 18:00
              horas.
            </p>
            <b>Responsable de Datos Personales. </b>
            <p>
              El responsable de los Datos Personales es el Área de PRIVACIDAD DE
              DATOS de ARTÍCULOS PROMOCIONALES BRAND IN, S.A. DE C.V., la cual
              dará trámite a sus solicitudes y fomentará la protección de los
              Datos Personales.
            </p>
            <p>
              Por lo anterior, BRANDIN, pone a su disposición las siguientes
              formas de contacto y recepción de información y documentación
              relacionada:
            </p>
            <ul class="list-disc pl-6">
              <li>Nombre del responsable: Angela Arely Barranco Ayala</li>
              <li>Correo electrónico: arely.ayala@brandin.com.mx</li>
              <li>
                Dirección: Avenida Vasco De Quiroga, Número 3900, A-401, Santa
                Fe Cuajimalpa, Alcaldía Cuajimalpa De Morelos, En La Ciudad De
                México, Código Postal 05348.
              </li>
              <li>Teléfono: 5653279919</li>
              <li>Horario: Lunes a viernes de 8:00 am a 6:00 pm</li>
            </ul>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>VII. REVOCACIÓN DEL CONSENTIMIENTO. </b>
            <p>
              Usted podrá revocar su consentimiento para el tratamiento de sus
              datos personales enviando una solicitud al correo
              arely.ayala@brandin.com.mx. Sin embargo, debe tener en cuenta que,
              en algunos casos, la revocación podría implicar que no podamos
              seguir prestando los servicios o mantener la relación comercial.
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>VIII. CAMBIOS AL AVISO DE PRIVACIDAD. </b>
            <p>
              BRANDIN podrá modificar este Aviso de Privacidad en cualquier
              momento. En caso de modificaciones sustanciales, BRANDIN
              notificará a los Titulares mediante correo electrónico registrado
              o a través de un aviso destacado en el sitio web. :
            </p>
          </div>
          <div class="flex flex-col w-full text-justify space-y-2">
            <b>IX. ACEPTACIÓN DEL AVISO DE PRIVACIDAD. </b>
            <p>
              Al proporcionar sus datos personales a BRANDIN en su carácter de
              proveedor, usted reconoce haber leído y comprendido este Aviso de
              Privacidad y manifiesta su consentimiento para el tratamiento de
              los datos conforme a los términos aquí previstos.
            </p>
          </div>
          <div class="flex flex-col w-full justify-end text-right space-y-2">
            <p>Última actualización 15 de mayo de 2025</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'

export default {
  components: {
    Navbar,
    Footer
  }
}
</script>

<style scoped>
.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 480px;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}
div > b{
  margin-top: 8px;
}
</style>
